






































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { SwScrollView } from '@libs/unified-ui-framework/src/shared/sw-scroll-view';

@Component({
  components: {
    SwIcon,
    SwScrollView,
  },
})
export default class SwSecurityCenterToggleModal extends Vue {
  @Prop({ type: String, required: true })
  title: string;

  @Prop()
  left: number;

  @Prop()
  height: number;

  @Prop()
  width: number;

  @Prop()
  value: boolean;

  internalDisplay = this.value;

  @Watch('value')
  onDisplayChange(val: boolean) {
    this.internalDisplay = val;
  }

  @Watch('internalDisplay')
  onInternalDisplayChange() {
    this.$emit('input', this.internalDisplay);
  }
}
